import { ColorOak, LegsColorSteel, TopColorCeramic, TopColorFenix } from '../__generated/model/index.js';
export const SteelLegsSwatchMap = {
    [LegsColorSteel.RAL9005]: {
        color: '#1A1A1A',
        swatchName: 'RAL 9005'
    },
    [LegsColorSteel.RAL9016]: {
        color: '#DDDDDD',
        swatchName: 'RAL 9016'
    },
    [LegsColorSteel.AnodicGold]: {
        color: '#8F6941',
        swatchName: 'Anodic Gold'
    },
    [LegsColorSteel.AnodicBronze]: {
        color: '#8C7853',
        swatchName: 'Anodic Bronze'
    },
    [LegsColorSteel.AnodicBrown]: {
        color: '#563435',
        swatchName: 'Anodic Brown'
    }
};
export const TopColorCeramicSwatchMap = {
    [TopColorCeramic.CuarzoReno]: {
        color: '#C0C0C0',
        swatchName: 'Cuarzo Reno',
        thumbnailUrl: '/images/swatches/cuarzo_reno.webp'
    },
    [TopColorCeramic.NeroZimbabwe]: {
        color: '#1A1A1A',
        swatchName: 'Nero Zimbabwe',
        thumbnailUrl: '/images/swatches/nero_zimbabwe.webp'
    },
    [TopColorCeramic.BiancoSupreme]: {
        color: '#C0C0C0',
        swatchName: 'Bianco Supreme',
        thumbnailUrl: '/images/swatches/bianco_supreme.webp'
    },
    [TopColorCeramic.CalacataVaglie]: {
        color: '#C0C0C0',
        swatchName: 'Calacata Vaglie',
        thumbnailUrl: '/images/swatches/calacata_vaglie.webp'
    },
    [TopColorCeramic.TajMahal]: {
        color: '#C0C0C0',
        swatchName: 'Taj Mahal',
        thumbnailUrl: '/images/swatches/taj_mahal.webp'
    },
    [TopColorCeramic.MacchiaVecchia]: {
        color: '#C0C0C0',
        swatchName: 'Macchia Vecchia',
        thumbnailUrl: '/images/swatches/macchia_vecchia.webp'
    },
    [TopColorCeramic.CalacataNaturel]: {
        color: '#C0C0C0',
        swatchName: 'Calacata Natural',
        thumbnailUrl: '/images/swatches/calacata_naturel.webp'
    },
    [TopColorCeramic.BlueStoneNegro]: {
        color: '#1A1A1A',
        swatchName: 'Bluestone Negro',
        thumbnailUrl: '/images/swatches/blue_stone_negro.webp'
    },
    [TopColorCeramic.CeppoDeGre]: {
        color: '#808080',
        swatchName: 'Ceppo di Gré',
        thumbnailUrl: '/images/swatches/ceppo_de_gre.webp'
    },
    [TopColorCeramic.NeroArdi]: {
        color: '#1A1A1A',
        swatchName: 'Nero Ardi',
        thumbnailUrl: '/images/swatches/nero_ardi.webp'
    },
    [TopColorCeramic.PaladioNaturel]: {
        color: '#1A1A1A',
        swatchName: 'Paladio Natural',
        thumbnailUrl: '/images/swatches/paladio_naturel.webp'
    },
    [TopColorCeramic.CalceGrigio]: {
        color: '#C0C0C0',
        swatchName: 'Calce Grigio',
        thumbnailUrl: '/images/swatches/calce_grigio.webp'
    },
    [TopColorCeramic.TitanCemento]: {
        color: '#808080',
        swatchName: 'Titan Cemento',
        thumbnailUrl: '/images/swatches/titan_cemento.webp'
    },
    [TopColorCeramic.LavaCorten]: {
        color: '#1A1A1A',
        swatchName: 'Lava Corten',
        thumbnailUrl: '/images/swatches/lava_corten.webp'
    },
    [TopColorCeramic.BasicNieve]: {
        color: '#C0C0C0',
        swatchName: 'Basic Nieve',
        thumbnailUrl: '/images/swatches/basic_nieve.webp'
    },
    [TopColorCeramic.Travertin]: {
        color: '#C0C0C0',
        swatchName: 'Travertin',
        thumbnailUrl: '/images/swatches/travertin.webp'
    },
    [TopColorCeramic.CalacataGold]: {
        color: '#C0C0C0',
        swatchName: 'Calacata Gold',
        thumbnailUrl: '/images/swatches/calacata_gold.webp'
    },
    [TopColorCeramic.SurfaceSand]: {
        color: '#C0C0C0',
        swatchName: 'Surface Sand',
        thumbnailUrl: '/images/swatches/surface_sand.webp'
    },
    [TopColorCeramic.SurfaceOffWhite]: {
        color: '#C0C0C0',
        swatchName: 'Surface Off White',
        thumbnailUrl: '/images/swatches/surface_off_white.webp'
    },
    [TopColorCeramic.NoirDesir]: {
        color: '#1A1A1A',
        swatchName: 'Noir Desir',
        thumbnailUrl: '/images/swatches/noir_desir.webp'
    },
    [TopColorCeramic.SurfaceCoolGrey]: {
        color: '#808080',
        swatchName: 'Surface Cool Grey',
        thumbnailUrl: '/images/swatches/surface_cool_grey.webp'
    },
    [TopColorCeramic.HyperWhite]: {
        color: '#C0C0C0',
        swatchName: 'Hyper White',
        thumbnailUrl: '/images/swatches/hyper_white.webp'
    },
    [TopColorCeramic.DarkBlack]: {
        color: '#1A1A1A',
        swatchName: 'Dark Black',
        thumbnailUrl: '/images/swatches/dark_black.webp'
    },
    [TopColorCeramic.ClassicCarrara]: {
        color: '#C0C0C0',
        swatchName: 'Classic Carrara',
        thumbnailUrl: '/images/swatches/classic_carrara.webp'
    }
};
export const TopColorFenixSwatchMap = {
    [TopColorFenix.NeroIngo0720]: {
        color: '#141414',
        swatchName: 'Nero Ingo'
    },
    [TopColorFenix.BiancoKos0032]: {
        color: '#FCFCFC',
        swatchName: 'Bianco Kos'
    },
    [TopColorFenix.BeigeLuxor0719]: {
        color: '#B6A58B',
        swatchName: 'Beige Luxor'
    },
    [TopColorFenix.VerdeComodoro0750]: {
        color: '#6D7675',
        swatchName: 'Verde Comodoro'
    },
    [TopColorFenix.VerdeBrac0773]: {
        color: '#63796B',
        swatchName: 'Verde Brac'
    }
};
export const ColorOakSwatchMap = {
    [ColorOak.UltraMatteLak]: {
        color: '#D8AF87',
        swatchName: 'Ultra Matte Lak'
    },
    [ColorOak.Oyster]: {
        color: '#A47652',
        swatchName: 'Oyster'
    },
    [ColorOak.DarkOak]: {
        color: '#845737',
        swatchName: 'Dark Oak'
    },
    [ColorOak.Charcoal]: {
        color: '#553E2E',
        swatchName: 'Charcoal'
    },
    [ColorOak.SlateGrey]: {
        color: '#675144',
        swatchName: 'Slate Grey'
    },
    [ColorOak.CottonWhite]: {
        color: '#C4A68E',
        swatchName: 'Cotton White'
    },
    [ColorOak.Black]: {
        color: '#2B2B2B',
        swatchName: 'Black'
    }
};

//# sourceMappingURL=swatches.js.map